import api from "@axios";

export default {
  namespaced: true,
  state: () => ({
    regulation: {},
    loading: false,
  }),
  getters: {
    loading(state) {
      return state.loading;
    },
    regulation(state) {
      return state.regulation;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setRegulation(state, val) {
      state.regulation = val;
    },
  },
  actions: {
    async getRegulation({ commit }, id) {
      try {
        commit("setLoading", true);
        const res = await api.get(`v2/guest/regulations-contents/${id}`);
        if (res.data.data) commit("setRegulation", res.data.data);
        else throw "notFound";
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
